import { creditFacilityService } from '@afterpaytouch/portal-api/consumer/creditFacility'

export const {
  useCreateFacilityMutation,
  usePreAssessmentMutation,
  useCreateFacilityAssessmentMutation,
  useValidateFacilityIncomeMutation,
  useValidateFacilityExpensesMutation,
} = creditFacilityService
